import { render, staticRenderFns } from "./StackChart.vue?vue&type=template&id=0393d450&"
import script from "./StackChart.vue?vue&type=script&lang=js&"
export * from "./StackChart.vue?vue&type=script&lang=js&"
import style0 from "./StackChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0393d450')) {
      api.createRecord('0393d450', component.options)
    } else {
      api.reload('0393d450', component.options)
    }
    module.hot.accept("./StackChart.vue?vue&type=template&id=0393d450&", function () {
      api.rerender('0393d450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/StackChart.vue"
export default component.exports